export default "__VITE_ASSET__Do40GKnY__"